module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_PDF-Icon_black-c3eb181fb14d37528ec2549111883aa4.svg";